import { ApiError } from '@restaurant/api-client';
import { toast } from 'sonner';

export function errorText(err: unknown): string {
  if (err instanceof ApiError) {
    const fields = (err.details as { fieldErrors?: Record<string, string[]> } | undefined)?.fieldErrors;
    const first = fields ? Object.entries(fields).find(([, v]) => v?.length) : undefined;
    return first ? `${err.message}: ${first[0]} ${first[1][0]}` : err.message;
  }
  return err instanceof Error ? err.message : 'Something went wrong';
}

export const toastError = (err: unknown) => toast.error(errorText(err));
